export function productLanding(hasApplication: (application: string) => boolean): string {
  if (hasApplication("AGENT_LAB")) return "/agent-builder/dashboard";
  if (hasApplication("LIVE_CONNECT")) return "/live/dashboard";
  if (hasApplication("DATALAKE")) return "/datalake/overview";
  return "/agent-builder/dashboard";
}
